import { gql } from "graphql-request";

export const READ_AUDIT_QUESTIONS = gql`
  query ReadAuditQuestions($industry: CompanyIndustry, $area: OperationalArea) {
    readAuditQuestions(industry: $industry, area: $area) {
      id
      industry
      area
      statement
      description
      sortOrder
      isActive
      isHighImpact
      createdAt
      updatedAt
    }
  }
`;

export const READ_AUDIT_QUESTION_BY_ID = gql`
  query ReadAuditQuestionByID($id: ID!) {
    readAuditQuestionByID(id: $id) {
      id
      industry
      area
      statement
      description
      sortOrder
      isActive
      isHighImpact
      createdAt
      updatedAt
    }
  }
`;